import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Tabs, Tab, Box } from "@mui/material";
import MainProduct from "./MainProduct";
import ProductWiseMachine from "./ProductWiseMachine";
import ViewBOM from "./ViewBOM";
import ViewBOMChemicals from "./ViewBOMChemicals"; // Import the new component
import ProductionSteps from "./ProductionSteps";
import RejectedRawMaterials from "./RejectedRawMaterials";
import ProductionCost from "./ProductionCost";

const ProductTabs = () => {
    const user = useSelector((state) => state.user);
      // const isAdmin = user?.role === 'Admin'; // Determine if the user is an Admin
      const [isAdmin, setIsAdmin] = useState(() => {
          if (!user || !user.department) return false; // Handle case where user or department is undefined
          const role = user.role?.toLowerCase();
          const department = user.department?.toLowerCase();
          // Check if user is Admin and department does not include Store or Supply or Others
          const isAdminRole = role === 'admin' && !department.includes('store') && !department.includes('supply') && !department.includes('others');
          
          // Check if user is Super Admin
          const isSuperAdminRole = role === 'super admin';
          return isAdminRole || isSuperAdminRole;
        });
    
      const navigate = useNavigate();
      const location = useLocation();
    
      useEffect(() => {
        if (!location.key || location.key === 'default') {
          navigate("/");
        }
      }, [location, navigate]);

    const [activeTab, setActiveTab] = useState(0);
    const [productId, setProductId] = useState(null); // State to hold the productId for ViewBOM
    const [bomId, setBomId] = useState(null); // State to hold the bomId for ViewBOMChemicals
    const [partId, setPartId] = useState(null); // State to hold the partId for ViewBOMChemicals

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const handleViewBOM = (id) => {
        setProductId(id); // Set the productId to be passed to ViewBOM
        setActiveTab(2); // Switch to the BOM tab
    };

    const handleViewChemicals = (bom_id, part_id) => {
        setBomId(bom_id); // Set the bomId to be passed to ViewBOMChemicals
        setPartId(part_id); // Set the partId to be passed to ViewBOMChemicals
        setActiveTab(3); // Switch to the BOM Chemicals tab
    };

    return (
        <Box ml={1}>
            {/* Tab Navigation */}
            <Tabs sx={{paddingLeft:"190px", paddingTop:"80px"}} value={activeTab} onChange={handleTabChange} variant="scrollable">
                <Tab label="Products" />
                <Tab label="Product Wise Machine" />
                <Tab label="BOM" />
                <Tab label="BOM Chemicals" /> {/* New tab for BOM Chemicals */}
                <Tab label="Production Steps" />
                <Tab label="Rejected Raw Materials" />
                {isAdmin && (<Tab label="Production Cost" />)}
            </Tabs>

            {/* Render Components Based on Active Tab */}
            <Box mt={2}>
                {activeTab === 0 && <MainProduct onViewBOM={handleViewBOM} />}
                {activeTab === 1 && <ProductWiseMachine />}
                {activeTab === 2 && <ViewBOM productId={productId} onViewChemicals={handleViewChemicals} />} {/* Pass onViewChemicals to ViewBOM */}
                {activeTab === 3 && <ViewBOMChemicals bomId={bomId} partId={partId} />} {/* Pass bomId and partId to ViewBOMChemicals */}
                {activeTab === 4 && <ProductionSteps />}
                {activeTab === 5 && <RejectedRawMaterials />}
                {activeTab === 6 && <ProductionCost />}
            </Box>
        </Box>
    );
};

export default ProductTabs;